export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

interface Props {
    content: string
    streaming: boolean
    loading: boolean
}

const FULL_CONTENT = [
    '# 发布方案建议',
    '',
    '下面是一轮包含多种富文本结构的综合回复，适合验证流式渲染体验。',
    '',
    '## 1. 核心结论',
    '',
    '- 组件主体建议先稳定富文本基础能力',
    '- 复杂能力按需启用，避免默认过重',
    '- 窄容器里优先保证表格、代码和图表仍可读',
    '',
    '## 2. 代码示例',
    '',
    '```ts',
    'interface MessageChunk {',
    '    type: "text" | "code" | "formula" | "diagram";',
    '    content: string;',
    '}',
    '',
    'export function appendChunk(source: string, chunk: MessageChunk) {',
    '    return source + chunk.content;',
    '}',
    '```',
    '',
    '## 3. 指标表',
    '',
    '| 指标 | 当前方案 | 优化方向 |',
    '| --- | --- | --- |',
    '| Bundle 成本 | 控制中 | 重能力继续按需化 |',
    '| 流式体验 | 可用 | 继续减少抖动 |',
    '| 窄容器可读性 | 基本可用 | 优先保证横向滚动 |',
    '',
    '## 4. 公式',
    '',
    '$$',
    '\\operatorname{score}(x)=\\sum_{i=1}^{n}\\frac{w_i\\cdot s_i}{1+\\exp(-x_i)}',
    '$$',
    '',
    '## 5. Mermaid',
    '',
    '```mermaid',
    'erDiagram',
    '   CUSTOMER ||--o{ ORDER : places',
    '   ORDER ||--|{ ORDER_ITEM : contains',
    '   PRODUCT ||--o{ ORDER_ITEM : includes',
    '```',
].join('\n');

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            content: '',
            streaming: false,
            loading: false,
        };
    }

    private timer: number | null = null;
    private loadingTimer: number | null = null;
    private cursor = 0;

    start() {
        this.reset();
        this.set('loading', true);

        this.loadingTimer = window.setTimeout(() => {
            this.loadingTimer = null;
            this.set({
                loading: false,
                streaming: true,
            });

            this.timer = window.setInterval(() => {
                this.cursor += 12;
                const nextContent = FULL_CONTENT.slice(0, this.cursor);
                this.set('content', nextContent);

                if (nextContent.length >= FULL_CONTENT.length) {
                    clearInterval(this.timer!);
                    this.timer = null;
                    this.set('streaming', false);
                }
            }, 80);
        }, 600);
    }

    reset() {
        if (this.timer !== null) {
            clearInterval(this.timer);
            this.timer = null;
        }

        if (this.loadingTimer !== null) {
            clearTimeout(this.loadingTimer);
            this.loadingTimer = null;
        }

        this.cursor = 0;
        this.set({
            content: '',
            streaming: false,
            loading: false,
        });
    }

    beforeUnmount() {
        this.reset();
    }
}